import axios from "axios";

export const state = {};

export const actions = {
  getTrip({ dispatch, commit }, params) {
    return axios
        .get(appUrl + "/api/trip/seat_map", {
          params,
          headers: { Authorization: "Bearer auth sau" },
        })
        .then((res) => {
          return res;
        })
        .catch((error) => {
          throw error;
        });
  },
};
